import { render } from "./TestimonialWidget.vue?vue&type=template&id=62f84c18"
import script from "./TestimonialWidget.vue?vue&type=script&lang=js"
export * from "./TestimonialWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__